import { useEffect, useState } from 'react'
import ListCloseIcon from '@pc/components/Works/Panel/shared/List/ListCloseIcon'
import ListItem from '@pc/components/Works/Panel/shared/List/ListItem'
import ListItemName from '@pc/components/Works/Panel/shared/List/ListItemName'
import ListItemParagraph from '@pc/components/Works/Panel/shared/List/ListItemParagraph'
import ListOpenIcon from '@pc/components/Works/Panel/shared/List/ListOpenIcon'
import type { Line, Station } from '@pc/components/Works/Panel/types'
import StationCheckboxes from './StationCheckboxes'
import type { ComponentPropsWithoutRef, MouseEvent } from 'react'

interface PropsType {
  line: Line
  stations: Station[]
  selectedStationIds: string[]
  changeStationIds: (stationIds: string[]) => void
}

const LineListItem = (props: ComponentPropsWithoutRef<'li'>) => <ListItem className="ml-5 cursor-pointer transition-all duration-200" {...props} />

const LineListItemParagraph = (props: ComponentPropsWithoutRef<'dl'>) => (
  <ListItemParagraph className="relative [&_svg]:absolute [&_svg]:right-4" {...props} />
)

const LineListItemName = (props: ComponentPropsWithoutRef<'dt'>) => <ListItemName className="min-w-62" {...props} />

const LineItem = (props: PropsType) => {
  const { line, stations, selectedStationIds, changeStationIds } = props
  const [childrenIsOpen, setChildrenIsOpen] = useState(false)

  const toggleChildren = (e: MouseEvent<HTMLElement>) => {
    e.preventDefault()
    setChildrenIsOpen(!childrenIsOpen)
  }

  useEffect(() => {
    const isSelectedBeforehand = stations.some((station) => selectedStationIds.includes(station.attributes.compat_id.toString()))
    if (isSelectedBeforehand) {
      setChildrenIsOpen(true)
    }
  }, [stations, selectedStationIds])

  return (
    <LineListItem>
      <LineListItemParagraph onClick={toggleChildren}>
        <LineListItemName>{line.attributes.name}</LineListItemName>
        {childrenIsOpen ? <ListCloseIcon /> : <ListOpenIcon />}
      </LineListItemParagraph>
      {childrenIsOpen && (
        <StationCheckboxes line={line} stations={stations} selectedStationIds={selectedStationIds} changeStationIds={changeStationIds} />
      )}
    </LineListItem>
  )
}

export default LineItem
